import React from 'react';
import { ShieldAlert, Zap, Brain } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { useThemeTokens } from '../hooks/useActiveTheme';

interface RemediationLoopProps {
  missedCount: number;
}

export const RemediationLoop: React.FC<RemediationLoopProps> = ({ missedCount }) => {
  const { certId } = useParams<{ certId: string }>();
  const currentCert = certId || 'cna';
  const tokens = useThemeTokens();

  if (missedCount === 0) return null;

  return (
    <div className={`${tokens.cardBg} rounded-3xl p-6 text-white relative overflow-hidden group border border-slate-200 dark:border-slate-800 shadow-xl`}>
      <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:scale-110 transition-transform duration-500">
        <Brain size={80} />
      </div>
      
      <div className="relative z-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-rose-500/20 border border-rose-500/30 rounded-full mb-4">
          <ShieldAlert size={14} className="text-rose-400" />
          <span className="text-[10px] font-black tracking-[0.2em] text-rose-300">Remediation Required</span>
        </div>
        
        <h3 className="text-xl font-black mb-2">Clean Up Your <span className="text-rose-400">Weak Points</span></h3>
        <p className="text-slate-300 dark:text-slate-400 text-sm font-medium mb-6 max-w-[240px]">
          You have {missedCount} critical gaps in your clinical logic. Closing these now increases exam readiness by 15%.
        </p>
        
        <Link 
          to={`/${currentCert}/missed`}
          className={`inline-flex items-center gap-3 px-6 py-3 ${tokens.primaryBtn} text-white rounded-xl font-bold text-sm tracking-tight transition-all shadow-xl`}
        >
          Fix Weak Points
          <Zap size={16} />
        </Link>
      </div>
    </div>
  );
};
